// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"63af17d5","437":"8ac97fc6","453":"07d8938f","679":"2b5f7210"}[chunkId] + ".chunk.js";
};